export const downloadBlob = (blobParts: BlobPart[], fileName: string) => {
  const fileURL = window.URL.createObjectURL(new Blob(blobParts))
  const link = document.createElement('a')
  link.href = fileURL
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.parentNode.removeChild(link)
}
